<template>
  <el-dialog
      title="新建自建库存"
      :visible.sync="dialogVisible"
      width="35%"
      >
      <div class="body">
        <el-button type="primary" @click="Selectproduct">选择已有产品</el-button>
        <el-col :span="24" style="margin-top:20px;">
        <el-upload
            :action="action"
            list-type="picture-card"
            :fileList="fileList"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :headers="customHeaders"
        >
            <i class="el-icon-plus" style="color: #0724ef;"></i>
        </el-upload>
        <el-divider></el-divider>
        <div class="form">
        <el-button type="primary" @click="AddprocurementLink">新增采购链接</el-button>
        <el-form ref="form" label-width="100px" style="margin-top:10px;">
            <div v-for="(item,index) in linkList" :key="index">
            <el-form-item label="采购链接:">
                <el-input style="width:250px;" v-model="linkList[index]"></el-input>
                <el-link :href="item" target="_blank" type="primary" style="margin-left:20px;height:20px;">访问</el-link>
                <el-link target="_blank" type="danger" style="margin-left:20px;height:20px;" @click="delLink(index)">删除采购链接</el-link>
            </el-form-item>
            </div>
            <el-form-item label="商品全称:">
                <el-input style="width:200px;" placeholder="全称" v-model="fullName"></el-input>
            </el-form-item>
            <el-form-item label="商品简称:">
                <el-input style="width:200px;" placeholder="简称" v-model="simpleName"></el-input>
            </el-form-item>
              <el-form-item label="型号尺码:">
                <el-input style="width:200px;" placeholder="尺寸" v-model="specification"></el-input>
            </el-form-item>
            <el-form-item label="商品描述:">
                <el-input  style="width:500px;" placeholder="规格型号说明" v-model="describe"></el-input>
            </el-form-item>
            <el-form-item label="库存申请数量:">
                <el-input-number v-model="Num"  :min="1" label="数量" size="mini"></el-input-number>
            </el-form-item>
        </el-form>
        </div>
        <el-dialog :visible.sync="ImageVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
        </el-col>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="Add">确定</el-button>
        </span>
        <el-dialog width="45%" title="选择已有产品" :visible.sync="innerVisible" append-to-body>
            <el-input v-model="searchInput" placeholder="库存编号、商品全称、商品简称" style="width: 65%;"></el-input>
            <el-button type="primary" @click="Searchproduct" style="margin-left:20px;">搜索</el-button>
            <div style="margin-top:15px;">
              <el-table :data="productList" border v-loading="loading" height="500">
                <el-table-column label="标题" width="180" align="center">
                    <template slot-scope="scope">
                        <el-link :underline="false" class="link">{{scope.row.productTitle}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="inventorySku" label="SKU" width="180" align="center"></el-table-column>
                <el-table-column label="图片" width="78" align="center">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="right">
                            <img :src="scope.row.skuImagesList[0]" class="prduct_img">
                            <div class="scope_img" slot="reference" >
                                <img :src="scope.row.skuImagesList[0]" alt style="width:50px;height:50px;"/>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column  label="货源" width="250" align="center">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.skuProductLinkList" :key="index">
                            <el-link :href="item" target="_blank" type="primary" class="link">{{item}}</el-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column  label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="determine(scope.row)">确定</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pagesize"
                    :current-page="currentPage"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
    data() {
        return {
            loading:"",
            dialogVisible:false,
            innerVisible:false,
            action: Baseurl + "imageController/uploadImage",
            dialogImageUrl: [],
            imageData: [],
            customHeaders: { token: localStorage.getItem("token") },
            fileList:[],
            ImageVisible:false,
            AddObj:{},
            searchInput:"",
            productList:[],
            linkList:[],
            imagesList:[],
            arrList:[],

            currentPage: 1,
            pagesize: 5,
            size: 10,
            total: 0,

            fullName:"",
            simpleName:"",
            describe:"",
            Num:"",
            inventorySku:"",
            specification:""
        }
    },
    created(){
        this.str = JSON.parse(localStorage.getItem("role"));
        let _this=this;
	    window.toWaringInfo2=_this.toWaringInfo2;
    },
    methods:{
        init() {
            this.dialogVisible = true;
        },
        Selectproduct(){
            this.innerVisible = true
            this.loading = true
            this.Searchproduct();
        },
        Searchproduct(){
            var obj = {
                page:this.currentPage,
                size:this.size,
                searchString:this.searchInput,
                type: "1",
                roleId:this.str.rid,
                companyId:this.str.company_id
            }
            ajaxPost(Baseurl + "inventoryController/selectSkuList",obj).then(res => {
                if(res.data.code == 200){
                    this.total = res.data.data.total
                    this.productList = res.data.data.list
                    this.loading = false
                } 
            })
        },
        handleSizeChange(val) {
            this.loading = true
            // console.log(`每页 ${val} 条`);
            this.size = val;
            var obj = {
                page:this.currentPage,
                size:this.size,
                searchString:this.searchInput,
                type: "1",
                roleId:this.str.rid,
                companyId:this.str.company_id
            }
            ajaxPost(Baseurl + "inventoryController/selectSkuList",obj).then(res => {
                if(res.data.code == 200){
                    this.total = res.data.data.total
                    this.productList = res.data.data.list
                    this.loading = false
                } 
            })
        },
        handleCurrentChange(val) {
            this.loading = true
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            var obj = {
                page:this.currentPage,
                size:this.size,
                searchString:this.searchInput,
                type: "1",
                roleId:this.str.rid,
                companyId:this.str.company_id
            }
            ajaxPost(Baseurl + "inventoryController/selectSkuList",obj).then(res => {
                if(res.data.code == 200){
                    this.total = res.data.data.total
                    this.productList = res.data.data.list
                    this.loading = false
                } 
            })
        },
        determine(val){
            this.innerVisible = false;
            // this.AddObj 
            console.log(val)
            this.linkList = val.skuProductLinkList
            this.inventorySku = val.inventorySku
            let urlStr = val.skuImagesList
            urlStr.forEach(item => {
                let obj = new Object();
                obj.url = item;
                this.fileList.push(obj);
            });
            this.AddObj.inventorySkus = [{
                        inventorySku:this.inventorySku,
                        skuType: "1",
                        skuProductLinkList:this.linkList,
                        skuImagesList:this.arrList
                    }];
            this.imagesList=this.fileList
        },
        handleRemove(file, fileList) {
            this.imagesList = fileList
            this.fileList = this.imagesList
            // console.log(this.imagesList)
        },
        handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.ImageVisible = true;
        },
        //图片上传
        handleAvatarSuccess(file, fileList) {
            file=Object.assign(file,{
                'url':file.data
            })
            this.fileList.push(file);
            this.imagesList = this.fileList
        },
        Add(){
            if(this.imagesList.length == 0){
                this.$message.error("上传图片不能为空！")
            }else if(this.linkList.length == 0){
                this.$message.error("至少添加一条采购链接")
            }else if(this.linkList[0] == ""){
                this.$message.error("采购链接不能为空")
            }else if(this.fullName == ""){
                this.$message.error("商品全称不能为空！")
            }else if(this.simpleName == ""){
                this.$message.error("商品简称不能为空！")
            }else if(this.specification == ""){
                 this.$message.error("型号尺寸不能为空！")
            }else if(this.describe == ""){
                this.$message.error("商品描述不能为空！")
            }
            else{
                this.dialogVisible = false
                // console.log(this.imagesList,'imagelist')
                for(var i=0;i<this.imagesList.length;i++){
                    this.arrList.push(this.imagesList[i].url)
                }
                this.AddObj = {
                     imagesList:this.arrList,
                    productLinkList:this.linkList,
                    productFullName:this.fullName,
                    productSimpleName:this.simpleName,
                    productDescription:this.describe,
                    predictCount:this.Num,
                    companyId:this.str.company_id,
                    roleId:this.str.rid,
                    inventorySku:this.specification,
                }
                // var obj = {
                //     imagesList:this.arrList,
                //     productLinkList:this.linkList,
                //     productFullName:this.fullName,
                //     productSimpleName:this.simpleName,
                //     productDescription:this.describe,
                //     predictCount:this.Num,
                //     companyId:this.str.company_id,
                //     roleId:this.str.rid,
                //     inventorySku:this.specification,
                //     inventorySkus:[{
                //         inventorySku:this.inventorySku,
                //         skuType: "1",
                //         skuProductLinkList:this.linkList,
                //         skuImagesList:this.arrList
                //     }]
                // }
                // console.log(obj);
                // return;
                ajaxPost(Baseurl + "inventoryController/insertInventory",this.AddObj).then(res => {
                    // console.log(res.data)
                    if(res.data.code == 200){
                        this.$message({
                            message: '新建自建库存成功',
                            type: 'success'
                        });
                        this.$emit("Addinventory")
                    }else(
                        this.$message.error(res.data.data)
                    )
                    this.linkList = [];
                    this.fileList = [];
                    this.arrList = [];
                    this.imagesList = [];
                    this.fullName = "";
                    this.simpleName = "";
                    this.describe = "";
                    this.Num = "";
                    this.specification = "";
                })
        }


        },
        cancel(){
            this.dialogVisible = false
            this.linkList = []
            this.fileList = []
            this.arrList = []
            this.imagesList = []
            this.fullName = ""
            this.simpleName = ""
            this.describe = ""
            this.Num = ""
        },
        AddprocurementLink(){
            // this.AddLink = true
            if(this.linkList.length<5){
                this.linkList.push("")
            }else if(this.linkList.length <= 5){
                this.$message.error('采购链接已达上限！');
            }
            // console.log(this.linkList)
        },
        delLink(index){
            if(this.linkList.length>1){
                this.linkList.splice(index,1)
                // console.log(index)
            }else{
                this.$message.error('采购链接最少保留一条！');
            }
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/{
    .el-pagination{
        margin-right: 0px!important;
    }
    .form .el-form-item{
        margin-bottom: 5px;
    }
}
</style>

<style>
.body{
    width: 100%;
}
.link{
    display: inline-block;
    width: 100%;
    height: 20px;
    text-align: center;
    line-height: 20px;
}
.prduct_img {
  width: 300px;
  height: 300px;
}
.page{
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>